import { createStore } from 'vuex';

export default createStore({
  state: {
    posts: [],
    user: '',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
